/**
 * The art library Webwin ships, registered on import: the scene art (`starfield`, `horizon`,
 * `embers`, `ring`, `sigil`, `rule`, `pool`), the `globe`, and the looks. All of it is art markup -
 * the XML beside this file - which is the proof that the language is enough to draw them.
 */
import { registerArtLibrary } from "../markup/library.js";
import "../markup/lookMarkup.js";
import globe from "./globe.xml?raw";
import looks from "./looks.xml?raw";
import scene from "./scene.xml?raw";

registerArtLibrary(scene);
registerArtLibrary(globe);
registerArtLibrary(looks);
